class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      if( this.dataset.bundle == "true" ){
       //this.closest('cart-items').updateQuantity(this.dataset.index, 0, 'bundle_feature');
       this.closest('cart-items').updateQuantity(this.dataset.index, 0, 'bundle_feature', null,this.dataset.key,);
      }else{
       this.closest('cart-items').updateQuantity(this.dataset.index, 0, null ,event);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);


//free-gift products remove element
class RemoveFreeGiftButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      let mainTimeStamp = event.target.dataset.isfreegiftid;
      //console.log('mainTimeStamp',mainTimeStamp);
      let removeBtn = document.querySelectorAll('.remove-mltiple a');   
      const toRemove = [];
      removeBtn.forEach((ele)=>{
        let crntLineIndex = ele.dataset.lineKey;
        let compareTimeStamp = ele.dataset.isfreegiftid;
        if(mainTimeStamp === compareTimeStamp){
          toRemove.push(ele.dataset.id);
        }
        //console.log('compareTimeStamp-->',compareTimeStamp);             
      });
      console.log('toRemove-->',toRemove);
      this.closest('cart-items').removeMultiple(toRemove);
    });
  }
}
customElements.define('cart-free-pd-remove-button', RemoveFreeGiftButton);


// class changeFreeGiftVariant extends HTMLElement {
//   constructor() {
//     super();
//     let selectOption = this.childNodes[3].children[0];
//     selectOption.addEventListener('change', (event) => {
//       event.preventDefault();
//       event.stopPropagation();
//       let slectedValId = event.target.options[event.target.selectedIndex].dataset.vid;
//       //console.log('event-->',event);
//       console.log('slectedValId-->',slectedValId);
//       this.closest('cart-items').changefreeGiftVariants(slectedValId);
//     });
//   }
// }
// customElements.define('variant-options', changeFreeGiftVariant);




class CartItems extends HTMLElement {
  constructor() {
    super();
    this.recommandaddpro();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'),event.target.attributes[0].nodeValue);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'cart-recomnd',
        section: document.getElementById('cart-recomnd').dataset.id,
        selector: '.js-cart-recomnd'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents-footer'
      }
    ];
  }

  updateQuantity(line, quantity, name,event,key=null) {
    
    var this_val = this;
    if( name == "bundle_feature" ){    

      let _updateData;
      if(key){
        _updateData = {};
        if(key.indexOf(',') > -1){
          let _newKey = key.split(',');
          for (let i = 0; i < _newKey.length; i++) {
            _updateData[_newKey[i]] = 0;
          }
        }else{
          _updateData[key] = 0;
        }
      }else{
        _updateData = line.split('+');
      }
      
      const body = JSON.stringify({
        //updates: line.split('+'),
        updates: _updateData,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });   
      console.log('body',body);
      
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();      
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
      
    }else{
      if(event != 'Option-Size'){
      if(event != 'quantity__input'){
        if(event.target.attributes[0].nodeValue == '39705704071225'){

          this_val.enableLoading(line);

          var chk_data = [];
          $.ajax({
            type: 'GET',
            url: '/cart.js',
            async: false,
            dataType: 'json',
            success: function(data1) { 
              var item = data1.items;
              chk_data[1] = 'false';
              chk_data[0] = data1.item_count;

              for(var i=0; i<item.length; i++){
                if(item[i].id == '39778870460473'){
                  chk_data[1] = 'true';
                  chk_data[2] = item[i].properties._payMonthly;
                  chk_data[3] = item[i].properties._recomendItem;
                }
              }
            }
          });

          if (myArr == true){
            if(event.target.attributes[0].nodeValue == '39705704071225' && chk_data[1] == 'true'){
              $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                async: false,
                data : "updates[39705704071225]=0&updates[39733319139385]=0",
                dataType: 'json',
                success: function(data1) {                
                  $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data : 'id=39778870460473&quantity=1'+'&properties%5B_payMonthly%5D='+chk_data[2]+'&properties%5B_recomendItem%5D='+chk_data[3],
                    dataType: 'json',
                    success: function(data2) {
                      fetch('/cart', { method: 'GET' }).then((response) => {
                        console.log('response ', response); return response.text();
                      }).then((state) => {
                        var parser = new DOMParser();
                        var doc = parser.parseFromString(state, 'text/html');
                        var stringToHTML = doc.body;
                        if( stringToHTML.querySelector('.page-width.is-empty') == null ){
                          var elementToReplace = document.querySelector('.main-cart-section .js-contents');
                          elementToReplace.innerHTML = stringToHTML.querySelector('.main-cart-section .js-contents').innerHTML;
                          var elementToReplace = document.querySelector('.main-cart-section .js-contents-footer');
                          elementToReplace.innerHTML = stringToHTML.querySelector('.main-cart-section .js-contents-footer').innerHTML;                      
                          this_val.disableLoading();
                        }else{
                          var elementToReplace = document.querySelector('.main-cart-section .page-width');
                          elementToReplace.innerHTML = stringToHTML.querySelector('.main-cart-section .page-width.is-empty').innerHTML;                        
                        }

                        var elementToReplace = document.querySelector('.js-cart-recomnd');

                        elementToReplace.innerHTML = stringToHTML.querySelector('.js-cart-recomnd').innerHTML; 
                        cartRecomndProList();
                      }).catch(() => {
                               this_val.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
                      document.getElementById('cart-errors').textContent = window.cartStrings.error;
                      this_val.disableLoading();
                    });
                  }
                         });
                }
              });
            }
            else{
              var clickOnRemove = event == null ? false : $(event.target).hasClass('has-cart-remove-button');
              const body = JSON.stringify({
                line,
                quantity,
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname
              });   

              fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
              .then((response) => {
                return response.text();
              })
              .then((state) => {

                const parsedState = JSON.parse(state);                      
                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartFooter = document.getElementById('main-cart-footer');
                const mainPageWidth = document.querySelector('.main-cart-section .page-width');

                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (mainPageWidth) mainPageWidth.classList.toggle('is-empty', parsedState.item_count === 0);
                this.getSectionsToRender().forEach((section => {
                  const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

                  if( clickOnRemove == false && section.id == "cart-recomnd_"){
                  }else{
                    elementToReplace.innerHTML =
                      this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                  }
                  if( clickOnRemove && section.id == "cart-recomnd_" ){
                    cartRecomndProList();
                  }
                }));

                this.updateLiveRegions(line, parsedState.item_count);
                const lineItem =  document.getElementById(`CartItem-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
                if($('.js-cart-recomnd .cart-recomnd-pro-list .recommended-pro-col').length > 0){ cartRecomndProList(); }
                this.disableLoading();
              }).catch(() => {
                       this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
              document.getElementById('cart-errors').textContent = window.cartStrings.error;
              this.disableLoading();
            });
          }
          }
          else{  
              var clickOnRemove = e == null ? false : $(e.target).hasClass('has-cart-remove-button');
              const body = JSON.stringify({
                line,
                quantity,
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname
              });   

              fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                const parsedState = JSON.parse(state);  
                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartFooter = document.getElementById('main-cart-footer');
                const mainPageWidth = document.querySelector('.main-cart-section .page-width');

                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (mainPageWidth) mainPageWidth.classList.toggle('is-empty', parsedState.item_count === 0);
                this.getSectionsToRender().forEach((section => {
                  const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

                  if( clickOnRemove == false && section.id == "cart-recomnd_"){
                  }else{
                    console.log(elementToReplace);
                    elementToReplace.innerHTML =
                      this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                  }
                  if( clickOnRemove && section.id == "cart-recomnd_" ){
                    cartRecomndProList();
                  }
                }));

                this.updateLiveRegions(line, parsedState.item_count);
                const lineItem =  document.getElementById(`CartItem-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
                if($('.js-cart-recomnd .cart-recomnd-pro-list .recommended-pro-col').length > 0){ cartRecomndProList(); }
                this.disableLoading();
              }).catch(() => {
                       this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
              document.getElementById('cart-errors').textContent = window.cartStrings.error;
              this.disableLoading();
            });
          }
        }
        else{
  //             this.enableLoading(line);
          console.log(event);
              var clickOnRemove = event == null ? false : $(event.target).hasClass('has-cart-remove-button');
              const body = JSON.stringify({
                line,
                quantity,
                sections: this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname
              });   




              fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                const parsedState = JSON.parse(state);
                console.log(this.getSectionsToRender(),'d');
                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartFooter = document.getElementById('main-cart-footer');
                const mainPageWidth = document.querySelector('.main-cart-section .page-width');

                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (mainPageWidth) mainPageWidth.classList.toggle('is-empty', parsedState.item_count === 0);
                this.getSectionsToRender().forEach((section => {


                  const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

                  if( clickOnRemove == false && section.id == "cart-recomnd_"){
                  }else{
  //                   console.log(section.id,'elementToReplace');
                    elementToReplace.innerHTML =
                      this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                  }
                  if( clickOnRemove && section.id == "cart-recomnd_" ){
                    cartRecomndProList();
                  }
                }));

                this.updateLiveRegions(line, parsedState.item_count);
                const lineItem =  document.getElementById(`CartItem-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
                if($('.js-cart-recomnd .cart-recomnd-pro-list .recommended-pro-col').length > 0){ cartRecomndProList(); }
                this.disableLoading();
              }).catch(() => {
                       this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
              document.getElementById('cart-errors').textContent = window.cartStrings.error;
              this.disableLoading();
            });
          }
      }
      else{
        console.log('sd',event,event.target);
        this_val.enableLoading(line);   
        var clickOnRemove = event == null ? false : $(event.target).closest('.cart-item__details').find('.cart-remove-button .button').hasClass('has-cart-remove-button');
        const body = JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        });   

        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          console.log(JSON.parse(state),'s');
          const parsedState = JSON.parse(state);      
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');
          const mainPageWidth = document.querySelector('.main-cart-section .page-width');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (mainPageWidth) mainPageWidth.classList.toggle('is-empty', parsedState.item_count === 0);
          this.getSectionsToRender().forEach((section => {

            const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if( clickOnRemove == false && section.id == "cart-recomnd_"){
            }else{
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
            if( clickOnRemove && section.id == "cart-recomnd_" ){
  //             cartRecomndProList();
            }
          }));

          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem =  document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
          if($('.js-cart-recomnd .cart-recomnd-pro-list .recommended-pro-col').length > 0){ cartRecomndProList(); }
          this.disableLoading();
        }).catch(() => {
                 this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
      }
	}  
    }
    
    
    
  }
  
  recommandaddpro(){
    $(document).on('click','.recomnd-add-pro',function(e){
      e.preventDefault();
      var v_id = $(this).attr('data-id');
      var v_handle = $(this).attr('data-handle');
      var addVid = $(this).closest('.recommended-pro-col').attr('data-vid');
      var payMonthly = $(this).closest('.recommended-pro-col').attr('data-monthly');
      var metaHandle = $(this).closest('.recommended-pro-col').attr('data-prop');
      $.ajax({
        url: "/cart/add.js",
        type: "POST",
        data: {
          quantity: 1,
          id: v_id,
          properties: {
            '_payMonthly': payMonthly,
            '_recomendItem': metaHandle,
            '_recomendItemAdded':''
          }
        },
        dataType: "json",
        success: function(response) {
          
//           location.reload();
          fetch('/cart', { method: 'GET' }).then((response) => {
            console.log('response ', response); return response.text();
          }).then((state) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(state, 'text/html');
            var stringToHTML = doc.body;
            if( stringToHTML.querySelector('.page-width.is-empty') == null ){
              var elementToReplace = document.querySelector('.main-cart-section .js-contents');
              elementToReplace.innerHTML = stringToHTML.querySelector('.main-cart-section .js-contents').innerHTML;
              var elementToReplace = document.querySelector('.main-cart-section .js-contents-footer');
              elementToReplace.innerHTML = stringToHTML.querySelector('.main-cart-section .js-contents-footer').innerHTML;                      
              
            }else{
              var elementToReplace = document.querySelector('.main-cart-section .page-width');
              elementToReplace.innerHTML = stringToHTML.querySelector('.main-cart-section .page-width.is-empty').innerHTML;                        
            }
            
            var elementToReplace = document.querySelector('.js-cart-recomnd');
            
            elementToReplace.innerHTML = stringToHTML.querySelector('.js-cart-recomnd').innerHTML; 
            cartRecomndProList();
            
            
            
          }).catch(() => {
          document.getElementById('cart-errors').textContent = window.cartStrings.error;
        });
        },
        error: function(error) {}
      });
    });
  }


  //Remove multiple item for free gift products

  removeMultiple(array) {
    var data = {updates:{}}, qty = 0;
    for (var i = 0; i < array.length; i++) {
      data.updates[array[i]] = qty;
    }
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(data2) {
        fetch('/cart', { method: 'GET' }).then((response) => {
          console.log('response ', response); return response.text();
        }).then((state) => {
          var parser = new DOMParser();
          var doc = parser.parseFromString(state, 'text/html');
          var stringToHTML = doc.body;
          if(data2.item_count == 0){
            document.querySelector('.main-cart-section .page-width').classList.add('is-empty');
          }else{
            document.querySelector('.main-cart-section .page-width').classList.remove('is-empty');
          }
          if( stringToHTML.querySelector('.page-width.is-empty') == null ){
            var elementToReplace = document.querySelector('.main-cart-section .js-contents');
            elementToReplace.innerHTML = stringToHTML.querySelector('.main-cart-section .js-contents').innerHTML;
            var elementToReplace = document.querySelector('.main-cart-section .js-contents-footer');
            elementToReplace.innerHTML = stringToHTML.querySelector('.main-cart-section .js-contents-footer').innerHTML;                      
          }else{
            var elementToReplace = document.querySelector('.main-cart-section .page-width');
            elementToReplace.innerHTML = stringToHTML.querySelector('.main-cart-section .page-width.is-empty').innerHTML; 
          }
        }).catch(() => {
          location.reload();
       });
      },
      error:function(error){
        console.log(error);
      }
    });
  }
  
  //END Remove multiple item for free gift products
  

  //check if free-gift products is there if there then load there varinat options
  //and append it to the cart template

  changefreeGiftVariants(addId){
    var freeGitPdHandle = '', freeGiftProp1 = '', freeGiftProp2 = '', crntFreeGiftVar = '';
    $.when(
    $.getJSON('/cart.js', function (cartData) {
      $.each(cartData.items, function(index, val) {
        if(val.properties._compareAt){
          console.log('val-->',val);
          freeGitPdHandle = val.handle;
          freeGiftProp1 = val.properties._compareAt;
          freeGiftProp2 = val.properties._freeGiftId;
          crntFreeGiftVar = val.key;
        }
      });
      console.log('crntFreeGiftVar-->',crntFreeGiftVar);
      console.log('freeGiftProp1-->',freeGiftProp1);
    })).then(
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: 'id='+crntFreeGiftVar+'&qty=0',
        dataType: 'json',
        success:function(data) {
          console.log('remove-->',data);
          setTimeout(() => {  
           $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {id: addId, qunatity:1, properties:{_compareAt: freeGiftProp1, _freeGiftId: freeGiftProp2, _recomendItem: '' } },
            dataType: 'json',
            success:function(data1) {
               console.log('add-->',data1);
              fetch('/cart', { method: 'GET' }).then((response) => {
                console.log('response ', response); return response.text();
              }).then((state) => {
                var parser = new DOMParser();
                var doc = parser.parseFromString(state, 'text/html');
                var stringToHTML = doc.body;
                if(data1.item_count == 0){
                  document.querySelector('.main-cart-section .page-width').classList.add('is-empty');
                }else{
                  document.querySelector('.main-cart-section .page-width').classList.remove('is-empty');
                }
                if( stringToHTML.querySelector('.page-width.is-empty') == null ){
                  var elementToReplace = document.querySelector('.main-cart-section .js-contents');
                  elementToReplace.innerHTML = stringToHTML.querySelector('.main-cart-section .js-contents').innerHTML;
                  var elementToReplace = document.querySelector('.main-cart-section .js-contents-footer');
                  elementToReplace.innerHTML = stringToHTML.querySelector('.main-cart-section .js-contents-footer').innerHTML;                      
                }else{
                  var elementToReplace = document.querySelector('.main-cart-section .page-width');
                  elementToReplace.innerHTML = stringToHTML.querySelector('.main-cart-section .page-width.is-empty').innerHTML; 
                }
              }).catch(() => {
                location.reload();
            });
          },
           error:function(error){
            console.log(error);
          }
        });
        },100);
        },
        error:function(error){
          console.log(error);
        },
        complete:function(){
      }
      }));
  }
  
  //End 

  

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
      );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);


//check if free-gift products is there if there then load there varinat options
//and append it to the cart template

$(document).ready(function(){
  if($('.cart-items .free-gift-dropdown').length > 0){
    
    
    $(document).on('change','.cart__items .free-gift-dropdown select', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).closest('.free-gift-select').find('.loading-overlay__spinner').removeClass('hidden');
      let freeGitPdHandle = '', freeGiftProp1 = '', freeGiftProp2 = '', crntFreeGiftVar = '';
      
      let newVarId = parseInt($(this).find('option:selected').attr('data-vid'));
      $.getJSON('/cart.js', function (cartData) {
        $.each(cartData.items, function(index, val) {
          if(val.properties != null){
            if(val.properties._compareAt != undefined || val.properties._compareAt != null){
              console.log('inner');
              freeGitPdHandle = val.handle;
              freeGiftProp1 = val.properties._compareAt;
              freeGiftProp2 = val.properties._freeGiftId;
              crntFreeGiftVar = val.id;
            }
          }
        });
      });
      
      var isALARendered;
      function ALAcheck() {
        isALARendered = setInterval(function () {
          customALA()
        }, 2000);
      }
      ALAcheck();
      function customALA() {
        if(freeGiftProp1 != '') {
          clearInterval(isALARendered);
          changefreeGiftVariants(newVarId,crntFreeGiftVar,freeGiftProp1,freeGiftProp2,$(this));
        }  
      }
      
    });
  }
});

function changefreeGiftVariants(addId,delId,p1,p2,thisd){
  console.log('addId',addId);
  console.log('delId',delId);

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {id: delId, quantity:0},
    dataType: 'json',
    success:function(data) {
    },
    error:function(error){
      console.log(error);
    },
    complete:function(){
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {id: addId, qunatity:1, properties:{_compareAt: p1, _freeGiftId: p2, _recomendItem: '' } },
        dataType: 'json',
        success:function(data) {
          fetch('/cart', { method: 'GET' }).then((response) => {
            console.log('response ', response); return response.text();
          }).then((state) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(state, 'text/html');
            var stringToHTML = doc.body;
            if(state.item_count == 0){
              document.querySelector('.main-cart-section .page-width').classList.add('is-empty');
            }else{
              document.querySelector('.main-cart-section .page-width').classList.remove('is-empty');
            }
            if( stringToHTML.querySelector('.page-width.is-empty') == null ){
              var elementToReplace = document.querySelector('.main-cart-section .js-contents');
              elementToReplace.innerHTML = stringToHTML.querySelector('.main-cart-section .js-contents').innerHTML;
              var elementToReplace = document.querySelector('.main-cart-section .js-contents-footer');
              elementToReplace.innerHTML = stringToHTML.querySelector('.main-cart-section .js-contents-footer').innerHTML;                      
            }else{
              var elementToReplace = document.querySelector('.main-cart-section .page-width');
              elementToReplace.innerHTML = stringToHTML.querySelector('.main-cart-section .page-width.is-empty').innerHTML; 
            }
            $(thisd).closest('.free-gift-select').find('.loading-overlay__spinner').addClass('hidden');
          }).catch((error) => {
           location.reload();
        });
        },
        error:function(error){
          console.log(error);
        },
        complete: function() {

        }
      });
    }
  });
}
